export default {
    lastCompleted: 1,
    skippedQuestions: [],
    skippedMode: false,
    additionalQuestions: [],
    questionnaireCompleted: false,
    answered: 0,
    randomNames: [],
    additionalQuestionsAnswered: false,
    hideFirstMessage: true,
    completed: null,
    finished: null,
    personalityTest: null,
    personalityTestVariant: 1,
    vitalQuestionsMissing: null,
    questionnaireQuestionsMissing: null,
};